"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunLottery = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var point_1 = require("../../model/point");
var service_1 = require("../../../library/base/service");
var RunLottery = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(RunLottery, _super);
    function RunLottery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '积分抽奖';
        _this.code = '101086';
        _this.desc = '积分抽奖';
        _this.requestParams = new point_1.RunLotteryRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return RunLottery;
}(service_1.BaseService));
exports.RunLottery = RunLottery;
//# sourceMappingURL=runLottery.js.map